import React, { useContext } from 'react';
import './style.scss';
import clsx from 'clsx';
import { SearchContext } from '../context/SearchContext';

const SearchCategories = () => {
  const {
    indexName,
    t,
    language,
    templateName,
    pageSize,
    helpers,
    inputSearchRef,
    pagination,
    dataRetrievedForCategory,
    setPagination,
    getSearchResultsWithoutSettingTotal,
    totalSearchResultsCount,
    setCurrentCategory,
    currentCategory,
    isCategoryDropdownOpen,
    setIsCategoryDropdownOpen,
    selectedCategory,
    setSelectedCategory,
  } = useContext(SearchContext);

  const onCategoryClick = (e, index, cat) => {
    setIsCategoryDropdownOpen((prev) => !prev);
    if (cat === null) {
      setCurrentCategory(t('All'));
    } else {
      setCurrentCategory(cat);
    }
    if (index === 0) {
      var newPagination = {
        ...pagination,
        currentPage: 1,
        itemsPerPage: pageSize?.value,
        itemsCount: totalSearchResultsCount,
        hasNext: pagination.pagesTotalNumber > 1,
        hasPrevious: false,
      };

      helpers({
        //we dont add pagesection to get all the results
        getSearchResultsWithoutSettingTotal, // get the results when we click on the category
        indexName,
        templateName,
        language,
        keyword: inputSearchRef?.current?.value,
        pagination: newPagination,
        pageSize: pageSize?.value,
      });
      setPagination(newPagination);
    } else {
      var newPagination = {
        ...pagination,
        currentPage: 1,
        itemsPerPage: pageSize?.value,
        itemsCount: totalSearchResultsCount,
        hasNext: pagination.pagesTotalNumber > 1,
        hasPrevious: false,
      };

      helpers({
        getSearchResultsWithoutSettingTotal, // get the results when we click on the category
        indexName,
        templateName,
        language,
        keyword: inputSearchRef?.current?.value,
        pagination: newPagination,
        pageSection: dataRetrievedForCategory[index - 1]?.value,
        pageSize: pageSize?.value,
      });
      setPagination(newPagination);
    }

    setSelectedCategory(index);
  };
  const opnCategoriesDropdown = () => {
    setIsCategoryDropdownOpen((prev) => !prev);
  };
  //get the categories

  return (
    <div className={clsx('search-categories', isCategoryDropdownOpen ? 'open' : '')}>
      <div
        className={clsx('mobile dropdown-category-all')}
        onClick={(e) => opnCategoriesDropdown(e)}
      >
        <div className="auto">
          <div className="selected-category flex-it flex-align-item-center">{currentCategory}</div>
        </div>
        <div className="arrow-down flex-it flex-align-item-center flex-justify-center">
          <img src={'/-/media/Project/FAB2/shared/images/icon-arrow_down.svg'} />
        </div>
      </div>

      <div className="search-listing-categories">
        <div
          className={clsx(
            'search-item-category flex-it flex-align-item-center',
            selectedCategory === 0 ? 'selected' : ''
          )}
          onClick={(e) => onCategoryClick(e, 0, null)}
        >
          {t('All')}
        </div>

        {dataRetrievedForCategory?.map((category, index) => {
          const shouldRenderCategory = !!category?.value;
          if (!shouldRenderCategory) {
            return null;
          }
          return (
            <div
              key={index}
              className={clsx(
                'search-item-category flex-it flex-align-item-center',
                selectedCategory === index + 1 ? 'selected' : ''
              )}
              onClick={(e) => onCategoryClick(e, index + 1, category?.value)}
            >
              {category?.value}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchCategories;
